import { FC, SVGProps } from 'react'

export const ProfileIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.9998 13.9094C14.9768 13.9094 18.3337 14.5557 18.3337 17.0491C18.3336 19.5433 14.9548 20.1663 10.9998 20.1663C7.02374 20.1662 3.66675 19.5199 3.66675 17.0266C3.66707 14.5327 7.04502 13.9095 10.9998 13.9094ZM10.9998 1.83325C13.6939 1.83325 15.8533 3.99156 15.8533 6.68384C15.853 9.3759 13.6938 11.5344 10.9998 11.5344C8.3068 11.5342 6.14746 9.37579 6.14722 6.68384C6.14722 3.99167 8.30665 1.83343 10.9998 1.83325Z"
        fill="#2D3039"
      />
    </svg>
  )
}
